export default "__VITE_ASSET__C$BtpWuj__"